var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareNodes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-nodes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 3.33333C11.1144 3.33333 10.6667 3.78105 10.6667 4.33333C10.6667 4.88562 11.1144 5.33333 11.6667 5.33333C12.219 5.33333 12.6667 4.88562 12.6667 4.33333C12.6667 3.78105 12.219 3.33333 11.6667 3.33333ZM9.33333 4.33333C9.33333 3.04467 10.378 2 11.6667 2C12.9553 2 14 3.04467 14 4.33333C14 5.622 12.9553 6.66667 11.6667 6.66667C10.9843 6.66667 10.3704 6.37379 9.94374 5.90688L5.97887 7.68461C5.9928 7.78776 6 7.89304 6 8C6 8.11036 5.99234 8.21893 5.97752 8.3252L9.93701 10.1005C10.3639 9.62931 10.9807 9.33333 11.6667 9.33333C12.9553 9.33333 14 10.378 14 11.6667C14 12.9553 12.9553 14 11.6667 14C10.378 14 9.33333 12.9553 9.33333 11.6667C9.33333 11.5432 9.34293 11.422 9.3614 11.3037L5.42199 9.53734C4.99432 10.0253 4.36647 10.3333 3.66667 10.3333C2.378 10.3333 1.33333 9.28866 1.33333 8C1.33333 6.71134 2.378 5.66667 3.66667 5.66667C4.37004 5.66667 5.00073 5.97789 5.42853 6.47015L9.36294 4.70607C9.34346 4.5847 9.33333 4.4602 9.33333 4.33333ZM3.66667 7C3.11438 7 2.66667 7.44772 2.66667 8C2.66667 8.55229 3.11438 9 3.66667 9C4.21895 9 4.66667 8.55229 4.66667 8C4.66667 7.44772 4.21895 7 3.66667 7ZM11.6667 10.6667C11.1144 10.6667 10.6667 11.1144 10.6667 11.6667C10.6667 12.219 11.1144 12.6667 11.6667 12.6667C12.219 12.6667 12.6667 12.219 12.6667 11.6667C12.6667 11.1144 12.219 10.6667 11.6667 10.6667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNodes);
export default __webpack_public_path__ + "static/media/share-nodes.d6aeafbb9de5b7dc689de9da752ee0b9.svg";
export { ForwardRef as ReactComponent };